import Form, {
  ButtonItem,
  ButtonOptions,
  CustomRule,
  Item,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "../../lib/notify";
import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { loginWithRecoveryCode } from "../../api/auth";
import { useAuth } from "../../contexts/auth";
import "./LoginWithRecoveryCodeForm.scss";

export const LoginWithRecoveryCodeForm = ({
  redirectLink = "/twoFactorAuthentication",
}: {
  redirectLink: string;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { signInAuth } = useAuth();
  const formData = useRef({ code: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setLoading(true);
      const { code } = formData.current;
      const result = await loginWithRecoveryCode(code);
      setLoading(false);
      if (result.isOk) {
        await signInAuth();
        navigate("/");
      } else {
        notify(result.error, "error", 2000);
      }
    },
    [navigate, signInAuth]
  );

  const validateCode = useCallback(({ value }) => value.length === 11, []);

  return (
    <form className="twofa-login-form" onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField="code"
          editorType="dxTextBox"
          editorOptions={{
            stylingMode: "filled",
            placeholder: t("Enter Recovery Code"),
            mode: "text",
          }}
        >
          <RequiredRule message={t("Code is required")} />
          <CustomRule
            message={t("Code must be exactly 11 digits")}
            validationCallback={validateCode}
          />
          <Label visible={false} />
          <Label text={t("Code")} />
        </Item>
        <ButtonItem>
          <ButtonOptions width="100%" type="default" useSubmitBehavior>
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width="24px" height="24px" visible />
              ) : (
                t("submit")
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      <div className="two-fa-recovery-link">
        <Link to={redirectLink}>{t("Back to two factory authentication")}</Link>
      </div>
    </form>
  );
};
